import { IData } from 'components/molecules/PredictionGrid/types';

export const columns: IData[] = [
  {
    name: 'collectDate',
    align: 'center',
    direction: 'asc',
    sortingEnabled: true,
    width: 110,
    title: 'Coleta',
  },
  {
    name: 'serieNumber',
    align: 'center',
    direction: 'asc',
    sortingEnabled: true,
    width: 120,
    title: 'Nº de série',
  },
  {
    name: 'tagCode',
    align: 'center',
    direction: 'asc',
    sortingEnabled: true,
    width: 100,
    title: 'TAG',
  },
  {
    name: 'h2',
    align: 'center',
    width: 100,
    title: 'H2',
    fullTitle: 'Hidrogênio',
  },
  {
    name: 'o2',
    align: 'center',
    width: 100,
    title: 'O2',
    fullTitle: 'Oxigênio',
  },
  {
    name: 'n2',
    align: 'center',
    width: 100,
    title: 'N2',
    fullTitle: 'Nitrogênio',
  },
  {
    name: 'co2',
    align: 'center',
    width: 100,
    title: 'CO2',
    fullTitle: 'Dióxido de Carbono',
  },
  {
    name: 'c2h4',
    align: 'center',
    width: 100,
    title: 'C2H4',
    fullTitle: 'Etileno',
  },
  {
    name: 'c2h6',
    align: 'center',
    width: 100,
    title: 'C2H6',
    fullTitle: 'Etano',
  },
  {
    name: 'c2h2',
    align: 'center',
    width: 100,
    title: 'C2H2',
    fullTitle: 'Acetileno',
  },
  {
    name: 'co',
    align: 'center',
    width: 100,
    title: 'CO',
    fullTitle: 'Monóxido de Carbono',
  },
  {
    name: 'ch4',
    align: 'center',
    width: 100,
    title: 'CH4',
    fullTitle: 'Metano',
  },
  {
    name: 'tgc',
    align: 'center',
    width: 100,
    title: 'TGC',
    fullTitle: 'Total de Gás Combustível',
  },
  {
    name: 'rateValue',
    align: 'center',
    direction: 'asc',
    sortingEnabled: true,
    width: 100,
    title: 'Taxa (%)',
  },
  {
    name: 'iecC57',
    align: 'center',
    direction: 'asc',
    sortingEnabled: true,
    width: 100,
    title: 'IEC C57',
  },
  {
    name: 'classification',
    align: 'center',
    direction: 'asc',
    sortingEnabled: true,
    width: 130,
    title: 'Classificação',
  },
  {
    name: 'omegaClassification',
    align: 'center',
    direction: 'asc',
    sortingEnabled: true,
    width: 130,
    title: 'Classificação Omega',
  },
  {
    name: 'recommendation',
    align: 'center',
    sortingEnabled: true,
    width: 140,
    title: 'Recomendação',
  },
  {
    name: 'omegaRecommendation',
    align: 'center',
    sortingEnabled: true,
    width: 140,
    title: 'Recomendação Omega',
  },
];
